import { useContext } from 'react'
import styled from '@emotion/styled'
import FormControl from '@mui/material/FormControl'
import Grid, { GridProps } from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { CvsTextField } from '@components'
import { useIntegrationAssignment } from '@global/hooks'
import { templateCopyContext } from '../../../../context'

const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
const TypographyBold = styled(Typography)`
  weight: 500;
`
const GridMargin = styled(Grid)<GridProps>`
  margin-top: 0;
  margin-bottom: 16px;
`
const FullWidthTextField = styled(CvsTextField as any)`
  width: 100%;
`

interface TextFieldProps {
  title: string
  desription?: string
  textValue: string | null
  integrationAssignment: any
  metadataKey: string
  label: string
}

export const TextField = ({
  title,
  desription,
  textValue,
  integrationAssignment,
  metadataKey,
  label,
}: TextFieldProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { onIntegrationMetadataChange } = useIntegrationAssignment({
    integrationAssignment,
    onChange,
  })

  return (
    <GridMargin container component={FormControl}>
      <TypographyBold variant="h4">{title}</TypographyBold>
      {desription && <NoMarginTypography variant="body2">{desription}</NoMarginTypography>}
      <FullWidthTextField
        margin="dense"
        variant="outlined"
        label={label}
        value={textValue}
        onChange={e => {
          onIntegrationMetadataChange(e.target.value, metadataKey)
        }}
      />
    </GridMargin>
  )
}
